// src/components/LandscapeAdvertis.jsx
import React from "react";
import HeaderDisplay from "./HeaderDisplay";
import { CampaignCarousel, RSSComponent } from "../../components"; 

import {
  AdvertGrid,
  TopSection,
  MiddleSection,
  BottomSection,
} from "../../assets/wrappers/LandscapeAdvertis.styles";

const LandscapeAdvertis = ({
  theme,
  currentTime,
  dayOfWeek,
  weather,
  address,
  campaigns,
  news,
  video,
  scheduleViewsMap, // ← הוסף כאן
}) => {
  return (
    <AdvertGrid
      backgroundImage={theme.image}
      background={theme.background}
    >
      <TopSection>
        <HeaderDisplay
          currentTime={currentTime}
          dayOfWeek={dayOfWeek}
          weather={weather}
          address={address}
          theme={theme}
          video={video}
          fontSize={"2.5rem"}
        />
      </TopSection>

      <MiddleSection>
        <CampaignCarousel
          campaigns={campaigns}
          padding="0px"
          margin="10px"
          scheduleViewsMap={scheduleViewsMap} // ← העבר הלאה
        />
      </MiddleSection>

      <BottomSection>
        {news && (
          <RSSComponent
            data={news}
            textColor={theme.rss.textColor}
            background={theme.rss.background}
            fontFamily={theme.rss.fontFamily}
            logoBackground={theme.rss.logoBackground}
            logoTextColor={theme.rss.logoTextColor}
          />
        )}
      </BottomSection>
    </AdvertGrid>
  );
};

export default LandscapeAdvertis;


